export default "__VITE_ASSET__B8HzG9RL__"